import React, { FunctionComponent } from 'react';
import { translate } from './CheckBoxFieldV2.translations';
import { FieldValidatorType, FieldWrapper } from '@progress/kendo-react-form';
import { BrassField, BrassFieldProps } from '../../Field';
import { BrassCheckBox, BrassCheckBoxProps } from '../../../..';
import { BrassError, BrassHint } from '../../../../labels';
import { BrassLoader } from '../../../../indicators';
import { requiredValidator } from '../../validators/required';
import { I18nService } from '../../../../../../services';
import { Label } from '@progress/kendo-react-labels';
import styles from './CheckBoxFieldV2.module.scss';

interface CheckBoxFieldInputProps extends BrassCheckBoxProps {
  value?: string;
  visited: boolean;
  maxLength?: number;
  disabled?: boolean;
  layout?: 'horizontal' | 'vertical';
  className_label?: string;
}

const CheckBoxFieldInput: FunctionComponent<CheckBoxFieldInputProps> = (
  props: any,
) => {
  const {
    validationMessage,
    touched,
    id,
    label,
    name,
    layout,
    valid,
    disabled,
    hint,
    required,
    loading,
    className_label,
    ...others
  } = props;

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hindId = showHint ? `${id}_hint` : '';
  const errorId = showValidationMessage ? `${id}_error` : '';
  const labelId = label ? `${id}_label` : '';

  return (
    <FieldWrapper>
      <BrassCheckBox
        id={id + name + 'checkboxId'}
        className={styles.checkbox}
        ariaDescribedBy={`${hindId} ${errorId}`}
        ariaLabelledBy={labelId}
        valid={valid}
        layout={layout || 'vertical'}
        disabled={disabled}
        name={name!}
        style={{ marginRight: 10 }}
        label={label!}
        {...others}
      />
      {showHint && <BrassHint id={hindId}>{hint}</BrassHint>}
      {showValidationMessage && (
        <BrassError id={errorId}>{validationMessage}</BrassError>
      )}
    </FieldWrapper>
  );
};

interface BrassCheckBoxFieldV2Props
  extends Omit<BrassFieldProps & CheckBoxFieldInputProps, 'valid,component'> {
  name?: string;
  label?: string;
  loading?: boolean;
  disabled?: boolean;
  validator?: FieldValidatorType[];
}

const BrassCheckBoxFieldV2: FunctionComponent<BrassCheckBoxFieldV2Props> = (
  props: BrassCheckBoxFieldV2Props,
) => {
  const { name, required, loading } = props;

  const validators = [];
  if (required) {
    validators.push(requiredValidator);
  }

  if (loading) {
    return (
      <BrassField
        {...props}
        disabled
        name={name!}
        component={BrassCheckBox}
        defaultValue={translate('loadingData')}
      />
    );
  }

  return (
    <BrassField
      {...props}
      name={name!}
      validator={validators}
      component={CheckBoxFieldInput}
      label={required ? `${props.label}*` : props.label}
    />
  );
};

export { BrassCheckBoxFieldV2 };
export type { BrassCheckBoxFieldV2Props };
